<template>
  <div class="personalCenter">
    <div class="personalCenter__header">
      <div class="back" @click="backPage()">
        <img src="./img/backPage.png" />
        <p>个人中心</p>
      </div>
    </div>
    <div class="personalCenter__body">
      <div class="content">
        <p>{{ firstStr }}</p>
        <div class="li">
          <div>用户名</div>
          <div class="em">{{ userInfo.loginName }}</div>
        </div>
        <div class="li">
          <div>使用人</div>
          <div class="em">
            <span>{{ userInfo.userName }}</span>
            <span class="edit" @click="editUserNameDialog()">编辑</span>
          </div>
        </div>
        <div class="li">
          <div>手机号</div>
          <div class="em">
            <span>{{ userInfo.phone || "无" }}</span>
            <span class="edit" @click="editPhoneDialog()">编辑</span>
          </div>
        </div>
        <div class="li">
          <div>密码</div>
          <div class="em">
            <span>********</span
            ><span class="edit" @click="editPasswordDialog()">编辑</span>
          </div>
        </div>

        <div class="btn" @click="exitLogin()">退出登录</div>

        <el-dialog
          title="修改使用人"
          :visible.sync="dialogVisible"
          width="30%"
          class="userCenterDialog"
          :close-on-click-modal="false"
        >
          <el-input v-model="input" placeholder="请输入内容"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel()" class="cancel">取 消</el-button>
            <el-button type="primary" @click="confirm()" class="confirmEdit"
              >确 定</el-button
            >
          </span></el-dialog
        >
        <el-dialog
          title="修改手机号"
          :visible.sync="dialogVisiblePhone"
          class="userCenterDialog"
          :close-on-click-modal="false"
        >
          <el-form :model="form" :rules="rule">
            <el-form-item prop="inputPhone">
              <el-input v-model="form.inputPhone">
                <template slot="prepend">+86</template></el-input
              >
            </el-form-item>
            <el-form-item prop="verifyCode">
              <div class="verifyCode">
                <el-input
                  v-model="form.verifyCode"
                  class="ipt"
                  placeholder="请输入验证码"
                ></el-input
                ><el-button
                  class="btn2"
                  @click="getVerifyCode()"
                  v-if="showCountDown"
                  >获取验证码</el-button
                >

                <div
                  class="recode"
                  style="margin-top: 20px; font-size: 14px; color: #7d879f"
                  v-if="!showCountDown"
                >
                  <span style="color: #2a62ff">{{ countDown }}s</span>
                  后重新获取
                </div>
              </div>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel()" class="cancel">取 消</el-button>
            <el-button
              type="primary"
              @click="confirmPhone()"
              class="confirmEdit"
              >确 定</el-button
            >
          </span></el-dialog
        >
        <el-dialog
          title="修改密码"
          :visible.sync="dialogVisiblePassword"
          class="userCenterDialog"
          :close-on-click-modal="false"
        >
          <el-form :model="form2" :rules="rule2">
            <el-form-item prop="oldPassword">
              <el-input
                v-model="form2.oldPassword"
                placeholder=" 请输入旧密码"
                show-password
                class="eaySty"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="newPassword">
              <el-input
                v-model="form2.newPassword"
                placeholder=" 请输入新密码"
                show-password
                autocomplete="off"
                class="eaySty"
              ></el-input>
            </el-form-item>
            <el-form-item prop="newPasswordAgain">
              <el-input
                v-model="form2.newPasswordAgain"
                placeholder=" 请输入确认新密码"
                class="eaySty"
                show-password
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel()" class="cancel">取 消</el-button>
            <el-button
              type="primary"
              @click="confirmPassword()"
              class="confirmEdit"
              >确 定</el-button
            >
          </span></el-dialog
        >
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";

let checkPhone = (rule, value, callback) => {
  let reg = /^1[34578]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码格式"));
  } else {
    callback();
  }
};

export default {
  name: "personalCenterPage",
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form2.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      firstStr: "",
      input: "",
      userInfo: {},
      countDown: 0,
      timer: null,
      dialogVisible: false,
      dialogVisiblePhone: false,
      dialogVisiblePassword: false,
      showCountDown: true,
      form: {
        inputPhone: "",
        verifyCode: "",
      },
      form2: {
        oldPassword: "",
        newPassword: "",
        newPasswordAgain: "",
      },
      rule: {
        inputPhone: [
          {
            validator: checkPhone,
            type: "number",
            required: true,
            trigger: "blur",
          },
        ],
      },
      rule2: {
        newPassword: [
          {
            min: 6,
            max: 16,
            required: true,
            trigger: "blur",
            message: "新密码长度必须在6~16位！",
          },
        ],
        newPasswordAgain: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    queryUserInfo() {
      Axios.ajax({
        url: "/user/getUserInfo",
        method: "post",
      }).then((res) => {
        this.userInfo = res.data;
        if (res.data.userName) {
          this.firstStr = res.data.userName.slice(0, 1);
        } else {
          this.firstStr = res.data.loginName.slice(0, 1);
        }
      });
    },
    editUserNameDialog() {
      this.dialogVisible = true;
      this.input = this.userInfo.userName;
    },
    editPhoneDialog() {
      this.dialogVisiblePhone = true;
      this.form.inputPhone = "";
      this.form.verifyCode = "";
      this.showCountDown = true;
    },
    editPasswordDialog() {
      this.dialogVisiblePassword = true;
      this.form2.oldPassword = "";
      this.form2.newPassword = "";
      this.form2.oldPasswordAgain = "";
    },
    cancel() {
      this.dialogVisible = false;
      this.dialogVisiblePhone = false;
      this.dialogVisiblePassword = false;
    },
    confirm() {
      Axios.ajax({
        url: "/user/updateUserName",
        method: "post",
        data: {
          userName: this.input,
        },
      }).then(({ data }) => {
        this.queryUserInfo();
        this.dialogVisible = false;
      });
    },
    getVerifyCode() {
      Axios.ajax({
        url: "/user/getPhoneVerifyCode",
        method: "post",
        data: { phone: this.form.inputPhone },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.getCountDown();
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },
    getCountDown() {
      if (!this.timer) {
        this.countDown = 60;
        this.showCountDown = false;
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= 60) {
            this.countDown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.showCountDown = true;
          }
        }, 1000);
      }
    },
    confirmPhone() {
      Axios.ajax({
        url: "/user/updatePhone",
        method: "post",
        data: {
          phone: this.form.inputPhone,
          verifyCode: this.form.verifyCode,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.queryUserInfo();
          this.dialogVisiblePhone = false;
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },
    confirmPassword() {
      Axios.ajax({
        url: "/user/changePwd",
        method: "post",
        data: {
          oldPwd: this.$md5(this.form2.oldPassword),
          newPwd: this.$md5(this.form2.newPassword),
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.queryUserInfo();
          this.dialogVisiblePassword = false;
        } else {
          this.$message.warning(res.resultMessage);
        }
      });
    },

    exitLogin() {
      this.$router.push("/newlogin");
    },
    backPage() {
      // if (sessionStorage.getItem("url") == 1 || null) {
      //   this.$router.push("/areaUer");
      // } else if (sessionStorage.getItem("url") == 2) {
      //   this.$router.push("/singerUer");
      // } else {
      //   this.$message.warning("暂无该功能");
      // }
      this.$router.push("/newhome");
    },
  },
  created() {
    this.queryUserInfo();
  },
};
</script>

<style lang="less" scoped>
.personalCenter {
  width: 100%;
  &__header {
    width: 100%;
    height: 56px;
    background-image: url("./img/header.png");
    display: flex;
    align-items: center;
    padding-left: 5%;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      p {
        font-size: 16px;
        margin-left: 18px;
        font-weight: normal;
        color: #ffffff;
      }
    }
  }
  &__body {
    margin-top: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .content {
      width: 748px;
      p {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        text-align: center;
        line-height: 72px;
        background: #2a62ff;
        font-size: 32px;
        color: #ffffff;
        margin-bottom: 60px;
      }
      .li {
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 18px;
        color: #252b3c;
        border-bottom: 1px solid #d4d7e0;
        .em {
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          color: #7d879f;
          .edit {
            border: 1px solid #7d879f;
            padding: 4px 18px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
      .btn {
        width: 108px;
        height: 40px;
        background: #2a62ff;
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
        padding: 11px 24px;
        margin-top: 70px;
        cursor: pointer;
      }
    }
  }
}
.confirmEdit {
  height: 40px !important;
  width: 108px;
  background: #2a62ff !important;
  border-radius: 4px !important;
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  margin-left: 40px !important;
}
.cancel {
  border-radius: 4px;
  border: 1px solid #7d879f;
  width: 108px;
  height: 40px !important;
}
</style>

<style lang="less">
.userCenterDialog {
  .el-input__icon {
    margin-top: 12px;
  }
  .el-dialog {
    width: 600px;
    margin-top: 25vh !important;
    padding: 5px 20px;
    background: #ffffff;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
      0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    .el-dialog__header {
      text-align: left !important;
      .el-dialog__title {
        color: #252b3c !important;
        font-size: 20px !important;
      }
      .el-dialog__headerbtn {
        font-size: 28px;
        .el-dialog__close {
          color: #252b3c !important;
        }
      }
    }
    .el-dialog__body {
      .el-input {
        padding-top: 25px;
        .el-input__inner {
          font-size: 16px !important;
          height: 50px !important;
          color: #252b3c !important;
        }
      }
    }
  }
}
.verifyCode {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ipt {
    width: 300px;
  }
  .btn2 {
    margin-top: 26px !important;
    height: 50px !important;
  }
  .eaySty {
    margin-top: 26px !important;
    height: 50px !important;
  }
}
</style>
